import { SupportingDocument } from '@/features/prescriptions/SupportingDocumentItem'
import { StoreApi } from 'zustand'
import { createContext } from 'react'

interface DocumentUploadFormState {
  requestId: string
  supportingDocuments: Array<SupportingDocument>
  addSupportingDocument: (document: SupportingDocument) => void
  removeSupportingDocument: (name: string) => void
  updateSupportingDocument: (
    name: string,
    updater: () => Partial<SupportingDocument>,
  ) => void

  onNext: () => void
  onPrev: () => void
}

type DocumentUploadFormStore = StoreApi<DocumentUploadFormState>
export const DocumentUploadFormContext =
  createContext<DocumentUploadFormStore | null>(null)
